import styled from 'styled-components';

import { styledReset } from '@pkg/primitives';

import { tokens } from './tokens';

export const StyledNftCardNotification = styled.div`
    ${styledReset.borderBox};
    display: grid;
    gap: ${tokens.stack.gap}px;
    align-content: end;
    justify-items: end;
`;
